import React from 'react';

const Equity = () => {
  return (
    <div className="page">
      <h1>Equity</h1>
      <p>Placeholder for equity view. Aggregate of retained earnings, capital contributions, and net worth components.</p>
    </div>
  );
};

export default Equity;
